import { useState } from "react";
import { Play, Youtube } from "lucide-react";

export const PROMO_VIDEO = {
  src: "/media/denticision-launch.mp4", poster: "/media/poster.jpg", youtube: "AwbSqywDmPg",
  vertical: "/media/denticision-launch-vertical.mp4", verticalPoster: "/media/poster-vertical.jpg", youtubeShort: "xH5a1RbDpM8",
};

export const TUTORIAL_VIDEO = {
  src: "/media/tutorial-horizontal.mp4", poster: "/media/tutorial-poster.jpg", youtube: "CKAmp_ys70k",
  vertical: "/media/tutorial-vertical.mp4", verticalPoster: "/media/tutorial-poster-vertical.jpg", youtubeShort: "vna4bJ0dOhw",
};

export const FEATURES_VIDEO = {
  src: "", poster: "/media/features-poster.jpg", youtube: "w7bhXs3scD0",
  verticalPoster: "/media/features-poster-vertical.jpg", youtubeShort: "l8h76n6TvUc",
};

export const WALKTHROUGH_VIDEO = {
  src: "", poster: "/media/walkthrough-poster.jpg", youtube: "bvy33QnHn-8",
  verticalPoster: "/media/walkthrough-poster-vertical.jpg", youtubeShort: "1c6FhUyBytc",
};

const isPhone = () => typeof window !== "undefined" && window.matchMedia("(max-width: 640px)").matches;

export function VideoPlayer({ video, testid, label, className = "" }) {
  const [playing, setPlaying] = useState(false);
  const [vertical] = useState(() => isPhone() && !!video.youtubeShort);
  const id = vertical ? video.youtubeShort : video.youtube;
  return (
    <div className={vertical ? "max-w-sm mx-auto" : ""}>
      <div className={`relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 bg-black ${vertical ? "aspect-[9/16]" : "aspect-video"} ${className}`}>
        {playing ? (
          <iframe data-testid={testid} data-orientation={vertical ? "vertical" : "horizontal"} title={label} className="absolute inset-0 w-full h-full"
            src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
        ) : (
          <button type="button" onClick={() => setPlaying(true)} data-testid={`${testid}-play`} aria-label={label} className="absolute inset-0 group">
            <img src={vertical ? video.verticalPoster : video.poster} alt="" className="w-full h-full object-cover" />
            <span className="absolute inset-0 flex items-center justify-center bg-[#0B2545]/40 group-hover:bg-[#0B2545]/25 transition-colors">
              <span className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#1C6FE3] flex items-center justify-center shadow-xl transition-transform group-hover:scale-110">
                <Play className="w-9 h-9 sm:w-11 sm:h-11 text-white fill-white ml-1" />
              </span>
            </span>
          </button>
        )}
      </div>
      <a href={`https://www.youtube.com/watch?v=${video.youtube}`} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-youtube-link`}
        className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-slate-400 hover:text-red-500 transition-colors">
        <Youtube className="w-4 h-4" /> Watch on YouTube
      </a>
    </div>
  );
}

export function PromoVideo() {
  return (
    <section className="bg-[#0B2545] py-16" data-testid="promo-video-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white text-center">See DentiCision in action</h2>
        <p className="text-slate-300 text-center mt-2">One minute to see how dentists make confident, referenced decisions.</p>
        <div className="mt-8 text-center"><VideoPlayer video={PROMO_VIDEO} testid="promo-video" label="Play DentiCision video" /></div>
      </div>
    </section>
  );
}

const SITE = "https://denticision.com";
export const videoLd = (name, description, v, duration) => ({
  "@type": "VideoObject", name, description, thumbnailUrl: [`${SITE}${v.poster}`, `${SITE}${v.verticalPoster}`],
  uploadDate: "2026-10-11", ...(duration && { duration }), ...(v.src && { contentUrl: `${SITE}${v.src}` }), embedUrl: `https://www.youtube.com/embed/${v.youtube}`,
  sameAs: `https://www.youtube.com/watch?v=${v.youtube}`,
  publisher: { "@type": "Organization", name: "DentiCision", logo: { "@type": "ImageObject", url: `${SITE}/brand/denticision-logo-official.png` } },
});
